import React, {useContext, useEffect, useState} from 'react';
import Breadcrumb from '../shared/Breadcrumb';
import SideNav from './shared/SideNav';
import DataTable from 'react-data-table-component';
import { apiRoutes } from '../../AppSettings';
import { AuthContext } from '../../contexts/AuthContext';
import axios from 'axios';
import alertify from 'alertifyjs';
import './assets/css/adminstyle.css';
import { Link } from 'react-router-dom';
import PatientAvatar from './shared/PatientAvatar';

const customStyles = {
    title: {
        style: {
            fontSize: '12px', // override the row height
        }
    },
    rows: {
        style: {
            fontSize: '12px', // override the row height
        }
    },
    headCells: {
      style: {
        paddingLeft: '15px', // override the cell padding for head cells
        paddingRight: '15px',
        fontWeight: 'bold',
        fontSize: '15px'
      },
    },
    cells: {
      style: {
        paddingLeft: '15px', // override the cell padding for data cells
        paddingRight: '15px',
        paddingTop: '10px', // override the cell padding for data cells
        paddingBottom: '8px',
        fontSize: '15px',
      },
    },
  };



const Transactions = () => {
    const [data, setData] = useState([]);
    const { userState } = useContext(AuthContext);
   
    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + userState.token
        }
    };

    useEffect(() => {
        loadGrid();
    }, []);

    const loadGrid = () => {
        axios.get(apiRoutes.GetAllInvoices, options)
        .then((response) => {
            if (response.status === 200) {
                const data = response.data;
                setData(data);
            }
        }, (error) => {
            console.log(error);
        });
    }

    const handleDelete = (e, id) => {
        alertify.confirm("Warning!", "Are you sure want to delete?",
        function(){
            axios.post(apiRoutes.DeleteInvoice, JSON.stringify({id: id}), options)
            .then((response) => {
                alertify.success("Invoice deleted successfully");
                loadGrid();
            }, (error) => {
                console.log(error.response);
            });
        },
        function(){
            alertify.error('Cancel');
        });
    };

    const columns = [
        {
            name: 'Invoice Number',
            selector: 'invoiceNumber',
            sortable: true,
            width: '180px',
            cell: row => <div className="link"><Link to={
                            {
                                pathname:'/invoiceview',
                                state: {
                                    invoiceId: row.invoiceId
                                }
                            }
                        }>{row.invoiceNumber}</Link></div>
        },
        {
            name: 'Patient ID',
            selector: 'patientNumber',
            sortable: true,
            width: '150px',
            cell: row => <div>{row.appoinment.patient.patientNumber}</div>
        },
        {
            name: 'Patient Name',
            selector: 'name',
            sortable: true,
            width: '250px',
            cell: row => <PatientAvatar patient = {row.appoinment.patient} /> 
        },
        {
            name: 'Total Amount',
            selector: 'totalAmount',
            sortable: true,
            width: '180px',
            cell: row => <div>${row.totalAmount}</div>  
        },
        {
            name: 'Status',
            selector: 'paymentStatus',
            sortable: true,
            width: '150px',
            cell: row => <div><span className="badge badge-pill bg-success inv-badge">{row.paymentStatus}</span></div>
        },
        {
            name: 'Actions',
            selector: 'CreatedDate',
            sortable: true,
            width: '150px',
            cell: row => <div className="actions">
                            <Link className="btn btn-sm bg-danger-light" data-toggle="modal" href="#delete_modal" onClick={e => handleDelete(e, row.invoiceId)}>
                                <i className="fe fe-trash"></i> Delete
                            </Link>
                        </div>
        }
    ];

    return (  
        <div>
            <Breadcrumb title="Transactions"></Breadcrumb>
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <SideNav applyCssFor='transactions' />
                        </div>
                        <div className="col-md-7 col-lg-8 col-xl-9">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <DataTable
                                                title="Transactions"
                                                columns={columns}
                                                data={data}
                                                customStyles={customStyles}
                                                pagination
                                                highlightOnHover={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Transactions;